import { FaFileImport } from "react-icons/fa";

const BrowserTabIconInput = () => {
  return (
    <>
      <img src="logo192.png" alt="" width="24px" />
      <button>
        <FaFileImport />
      </button>
    </>
  );
};

export default BrowserTabIconInput;
